// productService.js

import omsAxiosInstance from "../omsAxiosInstance";

export const bulkUploadConfigService = {
  fetchUploadStatus: async (id) => {
    try {
      let response = await omsAxiosInstance.get(`/bulk-upload-status/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchUploadResults: async (id, limit, skip, status, signal) => {
    try {
      let query = `/bulk-upload-results?status_id=${id}&$limit=${limit}&$skip=${skip}`;
      if (status === "Valid") {
        query += `&message=Valid`;
      } else if (status === "Invalid") {
        query += `&message[$ne]=Valid`;
      }
      const response = await omsAxiosInstance.get(query, { signal });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  patch: async (id, data) => {
    try {
      let response = await omsAxiosInstance.patch(
        id,
        "/mapping-template",
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateUploadResult: async (data) => {
    let response = await omsAxiosInstance.post(`/update-verify-record`, data);
    return response.data;
  },

  startImport: async (data) => {
    let response = await omsAxiosInstance.post("/start-import", data);
    return response.data;
  },

  findConfigById: async (id) => {
    try {
      let response = await omsAxiosInstance.get(`/bulk-upload-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  downloadUploadResults: async (statusId, status) => {
    try {
      let response = await omsAxiosInstance.get(
        `/download-upload-results?status_id=${statusId}&status=${status}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  downloadSample: async (type) => {
    try {
      let response = await omsAxiosInstance.post(
        `/sample-template?type=${type}`,
        {
          dataType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
